import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextareaProps) {
  const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-487">
      {label && <label htmlFor={textareaId} className="block text-sm font-semibold text-white mb-2" data-id="element-488">
          {label}
        </label>}
      <textarea id={textareaId} className={`w-full px-4 py-3 bg-dark-surface text-white border-2 border-dark-border rounded-industrial focus:outline-none focus:border-brand-yellow transition-colors resize-vertical min-h-[120px] ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-489" />
      {error && <p className="mt-1 text-sm text-red-500" role="alert" data-id="element-490">
          {error}
        </p>}
    </div>;
}